import { Button, Drawer, Form, Space, Input } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BiExport } from "react-icons/bi";
import { BsEye } from "react-icons/bs";
import { RiFilterOffLine } from "react-icons/ri";
import Moment from "react-moment";
import { ExportToExcel } from "../../../../utils/XLSXExport";
import DetailsPanel from "./DetailsPanel";
import ExportBooking from "./ExportBooking";
const { Search } = Input;
export default function VehiclePanel({
  setVisible,
  isVisible,
  data,
  title,
}: any) {
  const [selected, setSelected] = useState<any>({});
  const [detailsModal, setDetailsModal] = useState<boolean>(false);
  const [search, setSearch] = useState("");

  const [form] = Form.useForm();

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  useEffect(() => {}, [data]);

  return (
    <Drawer
      title={`${title}`}
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="font-toyota">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search by registration"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
          </div>
          <div className="flex ">
            <ExportBooking bookings={data} />
          </div>
        </div>
        <div className="flex py-1 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-52 truncate font-bold">Customer</div>
              <div className="w-36 truncate text-left font-bold">Requested</div>
              <div className="w-28 truncate text-left font-bold">
                Registration
              </div>
              <div className="w-28 truncate text-left font-bold">Date</div>
            </div>
            <div className="font-bold w-full">
              <div className="flex">
                <div className="mr-2 text-left flex-1">Time</div>
                <div className="truncate flex justify-end">Details</div>
              </div>
            </div>
          </div>
        </div>
        {data
          ?.filter((item: any) => item?.vehicle?.includes(search))
          .map((item: any, index: number) => (
            <div className="flex py-1 border-b border-gray-300" key={index}>
              <div className="mr-2 w-10 text-center">{index + 1}.</div>
              <div className="flex justify-between items-center flex-1">
                <div className="flex items-center">
                  <div className="w-52">
                    {item?.customer_name === null ? "-" : item?.customer_name}
                  </div>
                  <div className="w-36 truncate">
                    {item?.createdAt === null ? (
                      "-"
                    ) : (
                      <Moment fromNow>{item?.createdAt}</Moment>
                    )}
                  </div>
                  <div className="w-28 truncate flex">
                    {item?.vehicle === null ? "-" : item?.vehicle}
                  </div>
                  <div className="w-28 truncate flex">
                    {item?.date === undefined || item?.date === null ? (
                      "-"
                    ) : (
                      <>
                        <Moment format="Do MMM, YYYY">{item?.date}</Moment>
                      </>
                    )}
                  </div>
                </div>
                <div className="w-full">
                  <div className="flex">
                    <div className="mr-2 text-left flex-1">
                      {item?.date === undefined || item?.date === null ? (
                        "-"
                      ) : (
                        <>
                          {item?.slottime === null ? (
                            "-"
                          ) : (
                            <>
                              <Moment format="HH:mm A">
                                {item?.slottime?.starttime}
                              </Moment>
                              <span className="mx-1">-</span>
                              <Moment format="HH:mm A">
                                {item?.slottime?.endtime}
                              </Moment>
                            </>
                          )}
                        </>
                      )}
                    </div>
                    <button
                      className="border p-2 hover:bg-red-50"
                      onClick={() => {
                        setSelected(item);
                        setDetailsModal(true);
                      }}
                    >
                      <BsEye />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        <div className="flex justify-between items-start border-t-2 border-b-2 py-2">
          <div className="ml-2">Total Bookings</div>
          <div className="font-bold">
            {
              data?.filter((item: any) => item?.vehicle?.includes(search))
                .length
            }
          </div>
        </div>
      </div>

      <DetailsPanel
        isVisible={detailsModal}
        setVisible={setDetailsModal}
        selected={selected}
      />
    </Drawer>
  );
}
